import { useState, useEffect } from 'react';
import { debounce, cloneDeep } from 'lodash';
import { Questionnaire } from '@/typings/Questionnaire';
import { useQuestionnaireFormContext } from '@/components/Questionnaire/QuestionnaireProvider';
import HandleAiAgentAutofills from './HandleAiAgentAutofills';
import HandleConditions from './HandleConditions';
import HandleAllAutofills from './HandleAutofills';
import HandleAutoSave from './HandleAutoSave';
import HandleFieldDynamicOptions from './HandleFieldDynamicOptions';

type Props = {
  formData: Questionnaire.Questionnaire;
  onStartAgent: Parameters<typeof HandleAiAgentAutofills>[0]['onStartAgent']
};
const HandleWatchers: React.FC<Props> = ({ formData, onStartAgent }) => {
  const {
    formMethods,
  } = useQuestionnaireFormContext();

  const [formValues, setFormValues] = useState<Record<string, unknown>>(formMethods.getValues());
  useEffect(() => {
    const debounceWatch = debounce((value) => {
      setFormValues(cloneDeep(value));
    }, 500);

    const subscription = formMethods.watch((value) => {
      debounceWatch(value);
    });
    return () => subscription.unsubscribe();
  }, [formMethods]);

  return (
    <>
      <HandleConditions
        sections={formData.sections}
      />
      <HandleAllAutofills
        formData={formData}
      />
      <HandleAiAgentAutofills
        questionnaireId={formData.id}
        onStartAgent={onStartAgent}
      />
      <HandleAutoSave
        formData={formData}
        formValues={formValues}
      />
      <HandleFieldDynamicOptions
        formData={formData}
        formValues={formValues}
      />
    </>
  );
};

export default HandleWatchers;